<div class="header">
    <h2>{{ 'schools.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="schools-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'schools.error.unavailable' | translate" />
} @else if (school(); as school) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'schools.fieldset.basic' | translate }}</h2>
            <div class="row">
                <app-form-input [control]="form.controls.name" [label]="'schools.form.name' | translate" inputId="name" testId="schools-edit-name" />
                <app-form-input
                    [control]="form.controls.shortName"
                    [label]="'schools.form.shortName' | translate"
                    inputId="shortName"
                    testId="schools-edit-short-name"
                />
            </div>

            <app-form-textarea
                [control]="form.controls.description"
                [label]="'schools.form.description' | translate"
                inputId="description"
                testId="schools-edit-description"
            />

            <app-form-input
                [control]="form.controls.rollNumber"
                [label]="'schools.form.rollNumber' | translate"
                inputId="rollNumber"
                testId="schools-edit-roll-number"
            />
        </div>

        <div class="section">
            <h2>{{ 'schools.fieldset.contact' | translate }}</h2>
            <app-form-autocomplete
                [control]="form.controls.contactEmail"
                [label]="'schools.form.contactEmail' | translate"
                [placeholder]="
                    adminEmails().length > 0
                        ? ('schools.form.contactEmail.suggestionsPlaceholder' | translate)
                        : ('schools.form.contactEmail.placeholder' | translate)
                "
                [suggestions]="adminEmails()"
                inputId="contactEmail"
                testId="schools-edit-contact-email"
            />
        </div>

        <div class="section">
            <h2>{{ 'schools.fieldset.courses' | translate }}</h2>
            <app-form-multiselect
                [control]="form.controls.courseIds"
                [label]="'schools.form.courses' | translate"
                [placeholder]="'schools.form.courses.placeholder' | translate"
                [options]="courseOptions()"
                [filter]="true"
                inputId="courseIds"
                testId="schools-edit-course-ids"
            />
        </div>

        <div class="section" formGroupName="address">
            <h2>{{ 'schools.fieldset.address' | translate }}</h2>
            <app-form-input
                [control]="form.controls.address.controls.street"
                [label]="'schools.form.street' | translate"
                inputId="street"
                testId="schools-edit-street"
            />

            <div class="row">
                <app-form-input
                    [control]="form.controls.address.controls.postalCode"
                    [label]="'schools.form.postalCode' | translate"
                    inputId="postalCode"
                    testId="schools-edit-postal-code"
                />
                <app-form-input
                    [control]="form.controls.address.controls.city"
                    [label]="'schools.form.city' | translate"
                    inputId="city"
                    testId="schools-edit-city"
                />
            </div>

            <app-form-select
                [control]="form.controls.address.controls.country"
                [label]="'schools.form.country' | translate"
                [options]="countryOptions"
                [filter]="true"
                inputId="country"
                testId="schools-edit-country"
            />
        </div>

        <div class="section">
            <h2>{{ 'schools.fieldset.importLearners' | translate }}</h2>
            <app-import-learners [schoolId]="school.id" />
        </div>
    </form>

    <div class="footer">
        <p-button [label]="'schools.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="schools-edit-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'schools.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="schools-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
